export const LENDER_NAME_INVALID = 'Invalid characters. Must be alphanumeric';
export const SALESFORCE_ID_INVALID = 'Invalid Salesforce ID. Must be 18 alphanumeric characters';
export const SALESFORCE_ID_DUPLICATE = 'Salesforce ID must be unique. This ID is already in use.';
export const NMLS_ID_INVALID = 'Invalid NMLS ID. Must contain only numeric characters';
export const ADDRESS_REQUIRED = 'Required';
export const ZIP_INVALID = 'Invalid format. Must be five numeric digits.';
export const EMAIL_INVALID = 'Invalid format';
export const EMAIL_DUPLICATE = 'Email must be unique. This email is already in use.';
/**
 * OM-4359 AC3. Kept apart from LENDER_NAME_INVALID — which stays on the person-name fields —
 * because an LOS login is strictly alphanumeric while a real name is not.
 */
export const LOGIN_INVALID = 'Invalid characters: Must be alphanumeric';
/** OM-4359 — verbatim from the ticket's Expected Behavior. */
export const ML_CONSUMER_USER_NAME_DUPLICATE =
  'MeridianLink Consumer User Name must be unique. This MeridianLink Consumer User Name is already in use.';
export const UNSAVED_TITLE = 'Unsaved Changes';
export const UNSAVED_BODY =
  'This page contains unsaved changes. All unsaved changes will be lost. Are you sure you want to exit?';
export const UNSAVED_CONFIRM = 'Exit Without Saving';
export const UNSAVED_CANCEL = 'Continue Editing Page';
export const DELETE_USER_TITLE = 'Delete User';
export const DELETE_USER_BODY = 'Are you sure you want to delete this user?';
export const REMOVE_LOS_TITLE = 'Unsaved Changes';
export const REMOVE_LOS_BODY = 'Are you sure you want to delete this LOS Integration?';
export const REMOVE_LOS_CONFIRM = 'Yes, Delete';
export const REMOVE_LOS_CANCEL = 'No, Continue Editing the LOS Integration';
export const MISSING_DATA_TITLE = 'Missing Data';
export const MISSING_DATA_BODY =
  'Are you sure you want to complete setup with missing data? You can add and edit data after setup.';
export const MISSING_DATA_CONFIRM = 'Yes, Complete Setup';
export const MISSING_DATA_CANCEL = 'No, Continue Editing';
export const USERS_INCOMPLETE_HINT =
  'Some users are missing information required by the selected LOS integrations. Edit the flagged users to continue.';
export const DISCARD_ACCESS_TITLE = 'Unsaved Changes';
export const DISCARD_ACCESS_BODY =
  'Turning this off discards any Products and Providers you deselected and reverts this user back to inheriting all Lender-enabled Products and Providers. Are you sure?';
export const DISCARD_ACCESS_CONFIRM = 'Yes, Discard';
export const DISCARD_ACCESS_CANCEL = 'No, Continue Editing Access';
export const STEP2_INSTRUCTION =
  "Select an LOS integration then fill out the required inputs. If more than one LOS Integration is needed, click 'Add Additional LOS' below.";
export const STEP3_INSTRUCTION =
  'Expand a Service category and toggle on the vendor products to enable for this lender.';
export const STEP4_ACCESS_HINT =
  "Toggle on to edit this user's Product and Provider access. Leave Off to inherit all Lender-enabled Products and Providers.";

export const EDIT_PRODUCT_ACCESS_LABEL = 'Edit Product and Provider Access';
export const ADD_USER_TITLE = 'Add User';
export const EDIT_USER_TITLE = 'Edit User';
export const EDIT_USER_CONFIRM = 'Save Changes';
export const STEP4_ACCESS_ON_TEXT =
  'All Products and Providers are enabled for this user based on Lender settings. Toggle off any Products and Providers this user should not have access to';

/** Shown on the lenders list right after a successful setup (OM-3921 AC12). */
export const SETUP_SUCCESS_NOTICE = 'Lender account created.';

/** OM-3918 AC5 — the Instance ID already belongs to a lender. Dialog body requested verbatim
 * by the client on the ticket (an Instance ID is immutable once created, so it no longer points
 * at Account Maintenance). */
export const instanceTakenError = (lenderName: string) =>
  `This Instance ID is currently linked to ‘${lenderName}’.`;
export const INSTANCE_TAKEN_TITLE = 'Instance ID Already in Use';
export const instanceTakenBody = (lenderName: string) =>
  `This Instance ID is currently linked to ‘${lenderName}’. An Instance ID cannot be changed once created.`;
export const INSTANCE_TAKEN_DISMISS = 'Close';
/** OM-3918: an ML Lender Code is unique per lender — inline error naming the holder. */
export const lenderCodeTakenError = (lenderName: string) =>
  `This Lender Code is currently linked to ‘${lenderName}’.`;

/**
 * The per-user Product Access panel, worded identically wherever it appears — Add User and
 * Edit User render the same panel, so the strings live here rather than once per drawer.
 */
export const ACCESS_HINT =
  "Toggle on to edit this user's product and vendor access. Leave off to inherit all lender enabled products and vendors.";
export const ACCESS_ON_TEXT =
  'All products are enabled by default based on your lender settings. Toggle off any products this user should not access.';
export const EDIT_ACCESS_LABEL = 'Edit product access';

/**
 * Reset Password, from Edit User (OM-4023 AC3). The body names the address the mail goes to:
 * the admin is acting on someone else's account, so the one detail worth confirming is who
 * receives the link.
 */
export const PASSWORD_RESET_LABEL = 'Reset Password';
export const PASSWORD_RESET_TITLE = 'Send a password reset email?';
export const passwordResetBody = (email: string) =>
  `A password reset link will be emailed to ${email}.`;
export const PASSWORD_RESET_CONFIRM = 'Send Email';
export const PASSWORD_RESET_SENDING = 'Sending…';
export const PASSWORD_RESET_CANCEL = 'Cancel';
export const PASSWORD_RESET_SENT = 'Password reset email sent.';
export const PASSWORD_RESET_FAILED = 'Unable to send the password reset email. Please try again.';

